import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  Input,
  ViewChild,
} from '@angular/core';
import { RecaptchaComponent as GRecaptcha } from 'ng-recaptcha';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-recaptcha',
  templateUrl: './recaptcha.component.html',
  styleUrls: ['./recaptcha.component.scss'],
})

/**
 * Recapcha component
 */
export class RecaptchaComponent implements AfterContentChecked {
  @Input() formGroup!: FormGroup;
  @Input() abstractFormControlName!: string;
  @ViewChild('captchaRef') captchaRef?: GRecaptcha;

  /**
   * Injects ChangeDetector so we can tell angular to detect
   * changes after view init
   * @constructor
   */
  constructor(private cd: ChangeDetectorRef) {}

  /**
   * Run  detection changes
   */
  ngAfterContentChecked(): void {
    this.cd.detectChanges();
  }

  /**
   * Resets recaptcha
   */
  reset() {
    this.captchaRef?.reset();
  }
}
